import { takeSnapshot } from '@Services/snapShot/snapshot.service.ts';
import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import { bugsnagClient } from '@Services/observability/initObservability';
import { ConsentTypes, getTermsAndConditions } from './termsAndConditions';

export const uploadConsent = async (
  type: ConsentTypes,
  fileName: string = 'Snapshot'
): Promise<boolean> => {
  const { customerId } = useBoundStore.getState().customer;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();

  return new Promise((res, rej) => {
    (async () => {
      const formData: FormData = new FormData();
      const snapShotBlob = await takeSnapshot();
      try {
        const consentResponse = await getTermsAndConditions(type);
        if (!snapShotBlob) return false;

        formData.append('image', snapShotBlob, fileName);
        formData.append(
          'consents',
          new Blob([JSON.stringify(consentResponse.termsAndConditions)], {
            type: 'application/json',
          }),
          'consents'
        );
        if (isEmbedded) {
          //TODO: Verify this logic is correct
          await HttpService.post(
            `v3/secureonboarding/partner/user/${customerId}/terms_and_conditions/consent`,
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' },
            }
          );
        }
        res(true);
      } catch (error) {
        console.error('Error uploading snapshot', error);
        rej(false);
      }
    })();
  });
};

export enum POATypes {
  PLAN_SELECTION = 'PLANS_SELECTION',
  KYB = 'KYB',
  OWNERS_CENTER = 'OWNERS_CENTER',
}

export const uploadGenericSnapshot = async (fileUsageType: POATypes, dataFileName = '') => {
  try {
    const {
      customer: { customerId },
      onboardingSlice: { getIsEmbedded },
    } = useBoundStore.getState();
    const formData = new FormData();
    const imageBlob = await takeSnapshot();
    if (!imageBlob) return false;
    const dataBlob = new Blob([
      JSON.stringify({
        fileUsageType: fileUsageType,
        fileName: dataFileName,
      }),
    ]);

    formData.append('image', imageBlob, Date.now().toString());
    formData.append('data', dataBlob);

    const uploadGenericImageUrl = getIsEmbedded()
      ? `v3/secureonboarding/partner/user/${customerId}/uploadImageFile`
      : `v1/user/${customerId}/uploadImageFile`;
    await HttpService.post(uploadGenericImageUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return true;
  } catch (e) {
    bugsnagClient.notify(`Error in uploading generic file: ${e}`);
    return false;
  }
};
